import { createContext } from 'react';
export var DropdownContext = createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    closeMenu: function () { },
});
//# sourceMappingURL=DropdownContext.js.map